robloxApp
    .constant("deviceTypes", {
        COMPUTER: "Computer",
        PHONE: "Phone",
        TABLET: "Tablet"
    });